import React, { useEffect, useRef, useState } from 'react';
import { STAGES } from '../lib/constantes';
import { db } from '../lib/firebase';

function GlobalSearchModal({ allowedCompanies, onSelectLead, onClose }) {
  const [q, setQ] = React.useState('');
  const [results, setResults] = React.useState([]);
  const [searching, setSearching] = React.useState(false);
  const inputRef = React.useRef();

  React.useEffect(() => { setTimeout(()=>inputRef.current?.focus(), 80); }, []);
  React.useEffect(() => {
    const h = e => { if (e.key==='Escape') onClose(); };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, []);

  React.useEffect(() => {
    const term = q.trim();
    if (term.length < 2) { setResults([]); return; }
    setSearching(true);
    const timer = setTimeout(async () => {
      try {
        const all = [];
        for (const co of allowedCompanies) {
          const snap = await db.collection('companies').doc(co.id).collection('leads').get();
          snap.docs.forEach(d => {
            const l = { id: d.id, ...d.data(), _co: co };
            const hay = [l.company_name, l.contact_name, l.contact_email, l.contact_phone, l.site, l.instagram, l.notes].join(' ').toLowerCase();
            if (hay.includes(term.toLowerCase())) all.push(l);
          });
        }
        all.sort((a,b) => {
          const ae = a.company_name?.toLowerCase().startsWith(term.toLowerCase()) ? 0 : 1;
          const be = b.company_name?.toLowerCase().startsWith(term.toLowerCase()) ? 0 : 1;
          return ae - be || (b.created_at||'').localeCompare(a.created_at||'');
        });
        setResults(all.slice(0, 25));
      } catch(e) { setResults([]); }
      setSearching(false);
    }, 350);
    return () => clearTimeout(timer);
  }, [q]);

  const dotColor = co => co.color==='red'?'bg-red-500':co.color==='orange'?'bg-orange-500':'bg-blue-500';

  return <div className="glass-overlay fixed inset-0 z-50 flex items-start justify-center p-4 pt-14" onClick={onClose}>
    <div className="w-full max-w-lg animate-sheet" onClick={e=>e.stopPropagation()}>
      <div className="acard rounded-2xl shadow-2xl overflow-hidden">
        <div className="flex items-center gap-3 px-4 py-3 border-b border-black/[0.06]">
          <svg className="w-5 h-5 text-gray-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
          <input ref={inputRef} className="flex-1 bg-transparent text-sm text-gray-900 placeholder-gray-400 outline-none font-medium"
            placeholder="Buscar por empresa, contato, telefone..."
            value={q} onChange={e=>setQ(e.target.value)} />
          {searching && <div className="w-4 h-4 border-2 border-blue-400 border-t-transparent rounded-full animate-spin flex-shrink-0"/>}
          <button onClick={onClose} className="text-xs text-gray-400 hover:text-gray-600 flex-shrink-0 font-medium">Esc</button>
        </div>
        {results.length > 0 && <div className="max-h-[420px] overflow-y-auto divide-y divide-black/[0.04]">
          {results.map(l => {
            const sm = STAGES.find(s=>s.key===l.stage);
            return <button key={`${l._co.id}-${l.id}`}
              onClick={()=>onSelectLead(l, l._co.id)}
              className="w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 text-left transition-colors">
              <span className={`w-2 h-2 rounded-full flex-shrink-0 mt-0.5 ${dotColor(l._co)}`}/>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm text-gray-900 truncate">{l.company_name}</div>
                <div className="text-xs text-gray-400 truncate">{[l.contact_name, l.contact_phone].filter(Boolean).join(' · ')}</div>
              </div>
              <div className="flex flex-col items-end gap-0.5 flex-shrink-0">
                {sm && <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${sm.color}`}>{sm.label}</span>}
                <span className="text-xs text-gray-400">{l._co.label}</span>
              </div>
            </button>;
          })}
        </div>}
        {q.trim().length >= 2 && !searching && results.length === 0 &&
          <div className="px-4 py-8 text-center text-sm text-gray-400">Nenhum lead encontrado para "<strong>{q}</strong>"</div>}
        {q.trim().length < 2 &&
          <div className="px-4 py-6 text-center text-xs text-gray-400">Digite ao menos 2 caracteres · busca em todas as empresas</div>}
      </div>
    </div>
  </div>;
}

export { GlobalSearchModal };
